<div class="">
    <div class="">
        <div>
            <div class="maintextContainer">
                <h1>Filter</h1>
                <i class="fa fa-times closebtn" aria-hidden="true" [mat-dialog-close]="true"></i>
            </div>
            <div class="col-md-12">
                <div>
                    <form [formGroup]="counsellingReport">
                        <!-- <div class="row mt-3"> -->
                        <div class="col-sm-12  mb-3 mt-3">
                            <mat-label class="font-size custom-label">Academic Year  <span style="color: RED;">*</span> </mat-label>
                            <mat-select class="form-control" placeholder="Select Academic year"
                                formControlName="Academic" (selectionChange)="onAcademicYearChange($event.value)">
                                <input matInput [matAutocomplete]="classauto" formControlName="Academic12"
                                    class="intbtn" placeholder="Select Academic year">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                                <mat-option *ngFor="let class of AcademicOptions | async" (click)="getCampus1(class)"
                                    (click)="clearCampus()" [value]="class?.year">
                                    {{class.year}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3 ">
                            <mat-label class="font-size custom-label">State <span style="color: RED;">*</span></mat-label>
                            <mat-select class="form-control" placeholder="Select State" formControlName="StateControl">
                                <input matInput [matAutocomplete]="classauto" formControlName="StateControl2"
                                    class="intbtn" placeholder="Select State">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                                <mat-option *ngFor="let class of stateOptions | async" (click)="getcity(class)"
                                    (click)="clearCity()" [value]="class?.stateId">
                                    {{class.stateName}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3 ">
                            <mat-label class=" font-size custom-label">City <span style="color: RED;">*</span> </mat-label>
                            <mat-select class="form-control" placeholder="Select City" formControlName="cityControl">
                                <input matInput [matAutocomplete]="classauto" formControlName="cityControl12"
                                    class="intbtn" placeholder="Select City">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>

                                <mat-option *ngFor="let class of cityOptions | async" (click)="getCampus(class)"
                                    (click)="clearCampus()" [value]="class?.cityId">
                                    {{class.cityName}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <mat-label class="font-size custom-label">Campus  </mat-label>
                            <mat-select class="form-control" placeholder="Select Campus"
                                formControlName="campusControl">
                                <input matInput [matAutocomplete]="classauto" formControlName="CampusControl2"
                                    class="intbtn" placeholder="Select Campus">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                                <mat-option *ngFor="let class of campusOptions | async" (click)="getconseller(class)"
                                    (click)="clearCounsler()" [value]="class?.campusId">
                                    {{class.campusName}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3 ">
                            <mat-label class="font-size custom-label">Counseller Name </mat-label>
                            <mat-select class="form-control" placeholder="Select Counseller Name"
                                formControlName="CounsellerControl">
                                <input matInput [matAutocomplete]="classauto" formControlName="CounsellerControl12"
                                    class="intbtn" placeholder="Select Counseller Name">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>

                                <mat-option *ngFor="let class of counserlistOptions | async"
                                    (click)="getreasonss(class)" (click)="clearReason()" [value]="class?.empId"(click)=getcounsellername(class)>
                                    {{class.empName}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <mat-label class="font-size custom-label">Search By Date Range</mat-label>

                            <div class="row">
                                <!-- Start Date -->
                                <div class="col-sm-6 mb-2">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>Start date</mat-label>
                                        <input matInput [min]="minFromDate" [max]="maxFromDate"
                                            [matDatepicker]="frompicker" (dateInput)="handleDateChange('start', $event)"
                                           formControlName="start" readonly>
                                        <mat-datepicker-toggle matSuffix [for]="frompicker"></mat-datepicker-toggle>
                                        <mat-datepicker #frompicker></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <!-- End Date -->
                                <div class="col-sm-6 mb-2">
                                    <mat-form-field appearance="fill" class="w-100">
                                        <mat-label>End date</mat-label>
                                        <input matInput [min]="minToDate" [max]="maxToDate" [matDatepicker]="topicker"
                                            (dateInput)="handleDateChange('end', $event)"  formControlName="end"  readonly>
                                        <mat-datepicker-toggle matSuffix [for]="topicker"></mat-datepicker-toggle>
                                        <mat-datepicker #topicker></mat-datepicker>
                                    </mat-form-field>
                                </div>

                            </div>
                        </div>
                        <!-- <div class="col-sm-12 mb-3">
                            <mat-label class="font-size custom-label">Referral&Reasons </mat-label>
                            <mat-select class="form-control" placeholder="Select Referral & Reasons"
                                formControlName="ReasonsControl">
                                <input matInput [matAutocomplete]="classauto" formControlName="ReasonsControl2"
                                    class="intbtn" placeholder="Select Referral & Reasons">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>

                                <mat-option *ngFor="let class of ReasonsOptions | async" (click)="getIssues(class)"
                                    (click)="clearIdentification()" [value]="class?.counselCatId">
                                    {{class.type}}</mat-option>
                            </mat-select>
                        </div> -->


                        <!-- <div class="col-sm-12 mb-3">
                        
                            <mat-label class="font-size custom-label">Issues</mat-label>
                            <mat-select class="form-control" placeholder="Select Issues Identified"
                                formControlName="IdentifiedControl" multiple>
                                <input matInput [matAutocomplete]="classauto" formControlName="IdentifiedControl2"
                                    class="intbtn" placeholder="Select Issues Identified">
                                <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>

                                <mat-option *ngFor="let class of IdentifiedOptions | async"
                                    [value]="class?.counselCatRsnId">
                                    {{class.reasonName}}</mat-option>
                            </mat-select>
                           
                        </div> -->

                        <!-- <div class="col-sm-6 d-flex align-items-center">
                                <mat-label class="me-2" style="min-width: 120px;">Campus </mat-label>
                                <mat-select class="form-control" placeholder="Select Campus"
                                    formControlName="CampusControl">
                                    <input matInput [matAutocomplete]="classauto" formControlName="CampusControl2"
                                        class="intbtn" placeholder="select Class">
                                    <mat-autocomplete autoActiveFirstOption
                                        #classauto="matAutocomplete"></mat-autocomplete>
                                        <mat-option value="hyderabad">Hyderabad</mat-option>
                                        <mat-option value="vizag">Vizag</mat-option>
                                        <mat-option value="vijayawada">Vijayawada</mat-option>
                                    <mat-option *ngFor="let class of campusOptions | async" (click)="getsection(class)"
                                        (click)="clearCampus()" [value]="class?.campusName">
                                        {{class.campusName}}</mat-option>
                                </mat-select>
                            </div> -->
                        <!-- </div> -->
                    </form>


                    <div class="col-lg-12 text-center mt-3">
                        <button type="button" class="applybtn" (click)="getReport()">Get Report</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ngx-spinner class="spinner" bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>